import {
  Accordion, AccordionDetails, AccordionSummary, Backdrop, Box, Button,
  CircularProgress, Container, Divider, FormControl, Grid, IconButton,
  InputAdornment, InputBase, InputLabel, MenuItem, Pagination,
  Paper, Select, Stack, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, styled, tableCellClasses
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect, useContext } from "react";
import { IPays, tableStyle } from "../Pays/Pays";
import Cookies from "universal-cookie";
import axios, { AxiosInstance } from "axios";
import { urlApi } from "../Pays/RowPays";
import ManagerOperationRow from "./ManagerOperationRow";
import ManagerOperationForm from "../../../forms/ManagerOperationForm";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { UserManagerOperationInterface } from "./UserManagerOperationInterface";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import { AlertType } from "../../../../types/AlertType";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import ClearIcon from "@mui/icons-material/Clear";
import { DataRef } from "../../../../types/DataRef";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CheckAttr from "../../../../utils/CheckAttr";
import { MediaQueryContext } from "../../../../utils/contextes/MediaQueryContext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 12,
  },
}));

export interface ClientWithOperations {
  id: number;
  libelle: string;
  operations: DataRef[];
}

const ManagerOperation = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [rowsManagerOperation, setRowsManagerOperation] = useState<
    UserManagerOperationInterface[]
  >([]);

  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");

  const [loader, setLoader] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<number | false>(false);

  const [page, setPage] = useState<number>(1);
  const [rowPerPage, setRowPerPage] = useState<number>(5);
  const [nb, setNb] = useState<number>(0);

  // Pour Recherche
  const [idPaysSearch, setIdPaysSearch] = useState<Number>();
  const [idClientSearch, setClientSearch] = useState<Number>();
  const [idOperationSearch, setIdOperationSearch] = useState<Number>();
  const [managerSearched, setManagerSearched] = useState<string>("");

  // Pour les Select
  const [allOperation, setAllOperation] = useState<DataRef[]>([]);

  // All Ref
  const [clientWithOperations, setClientWithOperations] = useState<
    ClientWithOperations[]
  >([]);
  const [dataRefPaysBu, setDataRefPaysBu] = useState<IPays[]>([]);

  const handleClose = () => {
    setOpenModal(false);
  };

  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove("jwt", { path: "/" });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const getPaginateManagerOperation = () => {
    const data = {
      rowPerPage: rowPerPage,
      page: page,
      idPays: idPaysSearch,
      idOperation: idOperationSearch,
      idClient: idClientSearch,
    };
    setLoader(true);
    http
      .post("get/manageroperation", data)
      .then((res) => {
        setRowsManagerOperation(res.data.data);
        setNb(res.data.total);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const getPaginateManagerOperationSearch = () => {
    const data = {
      rowPerPage: rowPerPage,
      page: page,
      manager: managerSearched,
    };
    setLoader(true);
    http
      .post("get/manageroperation", data)
      .then((res) => {
        setRowsManagerOperation(res.data.data);
        setNb(res.data.total);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getClientWithOperation = () => {
    if (idPaysSearch) {
      http.get(`client/get-with-operation-by-pays/${idPaysSearch}`)
        .then((res) => {
          Array.isArray(res.data) && setClientWithOperations(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const getOperationByPaysClient = () => {
    if (idPaysSearch && idClientSearch) {
      const data = {
        idPaysSearch: idPaysSearch,
        idClientSearch: idClientSearch
      }
      http.post("operation/get-operation/by-pays-client", data)
        .then((res) => {
          setAllOperation(res.data);
        })
        .catch((e) => {
          console.log("fh");
        })

    }
  }

  const getDataRef = () => {
    // Get Ref Pays With Bu Pour Ajout et Modifier
    http.get("allpaysbu")
      .then((res) => {
        setDataRefPaysBu(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // All Client With Child
    http.get("client/get-with-operation")
      .then((res) => {
        Array.isArray(res.data) && setClientWithOperations(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearch = () => {
    getPaginateManagerOperationSearch();
  };

  useEffect(() => {
    getPaginateManagerOperation();
  }, [
    page,
    rowPerPage,
    idPaysSearch,
    idClientSearch,
    idOperationSearch,
    refresh,
  ]);

  useEffect(() => {
    getClientWithOperation();
  }, [idPaysSearch]);

  useEffect(() => {
    getOperationByPaysClient();
  }, [idPaysSearch, idClientSearch]);

  useEffect(() => {
    getDataRef();
  }, []);

  const reloadList = () => {
    setRefresh(!refresh);
  };

  const handleRefresh = () => {
    setPage(1);
    setRowPerPage(5);
    setIdPaysSearch(undefined);
    setClientSearch(undefined);
    setIdOperationSearch(undefined);
    setManagerSearched("");
    reloadList();
  };

  const handleChangePaysFilter = (e: any) => {
    setIdPaysSearch(e.target.value as Number);
    setClientSearch(0);
    setIdOperationSearch(0);
    setPage(1);
  };

  const handleChangeClientFilter = (e: any) => {
    setIdOperationSearch(0);
    setPage(1);
    setClientSearch(e.target.value as number);
  };

  const pagination: JSX.Element | boolean = !loader && (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowPerPage}
          onChange={(e) => {
            setRowPerPage(e.target.value as number);
            setPage(1);
          }}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {nb > rowPerPage && (
        <Pagination
          count={Math.ceil(nb / rowPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => setPage(value)}
        />
      )}
    </Stack>
  );

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  return (
    <>
      <Container maxWidth="xl">
        {isDesktopOrLaptop ? (
          <>
            <Grid
              container
              spacing={0.5}
              columns={{ xs: 6, sm: 12, md: 12 }}
            >
              <Grid item xs={6} sm={3.5} md={4}>
                <Typography sx={{ display: "flex" }}>
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<AddIcon />}
                    onClick={(e) => {
                      setOpenModal(true);
                    }}
                    style={{ textTransform: "none" }}
                  >
                    Ajouter
                  </Button>
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2.5} md={1.5}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Pays
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="pays"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="pays"
                    value={idPaysSearch}
                    onChange={handleChangePaysFilter}
                  >
                    <MenuItem value={0}></MenuItem>
                    {dataRefPaysBu.map((item) => {
                      return <MenuItem value={item.id}>{item.libelle}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2.5} md={1.5}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Client
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="filter"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Age"
                    value={idClientSearch === 0 ? '' : idClientSearch}
                    onChange={handleChangeClientFilter}
                  >
                    <MenuItem value={''}></MenuItem>
                    {clientWithOperations !== undefined &&
                      clientWithOperations.map((item) => {
                        return <MenuItem value={item.id}>{item.libelle}</MenuItem>;
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2.5} md={1.5}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                  >
                    Opération
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="filter"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Age"
                    value={idOperationSearch === 0 ? "" : idOperationSearch}
                    onChange={(e) => setIdOperationSearch(e.target.value as Number)}
                  >
                    <MenuItem value={0}></MenuItem>
                    {allOperation !== undefined &&
                      allOperation.map((item) => {
                        return <MenuItem value={item.id}>{item.libelle}</MenuItem>;
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={12} md={3.5}>
                <Stack direction="row" display="flex" justifyContent="end">
                  <InputBase
                    sx={{ color: "white" }}
                    value={managerSearched}
                    placeholder="Chercher un manager ..."
                    onChange={(e) => setManagerSearched(e.target.value)}
                  />

                  <IconButton aria-label="refresh" sx={{ color: "#fff", pt: 0.5 }}>
                    <SearchIcon sx={{ fontSize: 35 }} onClick={handleSearch} />
                  </IconButton>

                  <IconButton aria-label="refresh" sx={{ color: "#fff", pt: 0.5 }}>
                    <RefreshIcon
                      sx={{ fontSize: 35 }}
                      onClick={() => handleRefresh()}
                    />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>

            <Box display="flex" justifyContent="left" mt={4}>
              {pagination}
            </Box>
            <TableContainer component={Paper} style={tableStyle} sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>Prénom</StyledTableCell>
                    <StyledTableCell>Nom</StyledTableCell>
                    <StyledTableCell>Pays</StyledTableCell>
                    <StyledTableCell>Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsManagerOperation.map((row) =>
                    row?.manager_operation_count > 0 && (
                      <ManagerOperationRow
                        key={row?.id}
                        row={row}
                        isDesktopOrLaptop={isDesktopOrLaptop}
                        dataRefPaysBu={dataRefPaysBu}
                        http={http}
                        clientWithOperations={clientWithOperations}
                        setOpenSnack={setOpenSnack}
                        setAlerteMessage={setAlerteMessage}
                        setAlertType={setAlertType}
                        handleRefresh={handleRefresh}
                        expanded={expanded}
                        setExpanded={setExpanded}
                      />
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box display="flex" justifyContent="right" mt={3} mb={5}>
              {pagination}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <Button
                variant="contained"
                size='small'
                startIcon={<AddIcon />}
                color="warning"
                fullWidth
                sx={{ textTransform: "none", mb: 1 }}
                onClick={() => setOpenModal(true)}
              >
                Ajouter
              </Button>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Filtre
                </AccordionSummary>
                <AccordionDetails>
                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(idPaysSearch) && "Pays"}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Pays"
                      value={idPaysSearch}
                      onChange={handleChangePaysFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataRefPaysBu.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="client" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(idClientSearch) && "Client"}
                    </InputLabel>
                    <Select
                      labelId="client"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Client"
                      value={idClientSearch}
                      onChange={handleChangeClientFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {clientWithOperations.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="operation" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(idOperationSearch) && "Opération"}
                    </InputLabel>
                    <Select
                      labelId="operation"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Opération"
                      value={idOperationSearch}
                      onChange={(e) => setIdOperationSearch(e.target.value as Number)}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {allOperation.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </AccordionDetails>
              </Accordion>

              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 1,
                  mt: 1,
                  mb: 3
                }}
                placeholder="Chercher un manager ..."
                size="small"
                fullWidth
                value={managerSearched}
                onChange={(e) => setManagerSearched(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => handleSearch()}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton
                        aria-label="refresh"
                        onClick={() => handleRefresh()}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Typography>Liste Manager par Opérations</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 1 }} />

              {!loader && nb > rowPerPage && (
                <Box display="flex" justifyContent="end">
                  <Pagination
                    count={Math.ceil(nb / rowPerPage)}
                    size="small"
                    color="standard"
                    sx={{ button: { color: "white" }, my: 1 }}
                    showFirstButton={true}
                    showLastButton={true}
                    siblingCount={0}
                    boundaryCount={1}
                    defaultPage={page}
                    onChange={(event, value) => setPage(value)}
                  />
                </Box>
              )}
            </Box>

            <Box mt='15rem'>
              {rowsManagerOperation.map((row) =>
                row?.manager_operation_count > 0 && (
                  <ManagerOperationRow
                    key={row?.id}
                    row={row}
                    isDesktopOrLaptop={isDesktopOrLaptop}
                    dataRefPaysBu={dataRefPaysBu}
                    http={http}
                    clientWithOperations={clientWithOperations}
                    setOpenSnack={setOpenSnack}
                    setAlerteMessage={setAlerteMessage}
                    setAlertType={setAlertType}
                    handleRefresh={handleRefresh}
                    expanded={expanded}
                    setExpanded={setExpanded}
                  />
                )
              )}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>
                Lignes par page :
              </InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12,
                  }}
                  value={rowPerPage}
                  onChange={(e) => setRowPerPage(e.target.value as number)}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}
      </Container>

      <OptionalWidthModal
        title="Ajouter Manager Par Operation"
        onClose={handleClose}
        open={openModal}
        breackPoint="md"
      >
        <ManagerOperationForm
          dataRefPaysBu={dataRefPaysBu}
          http={http}
          // clientWithOperations={clientWithOperations}
          handleRefresh={handleRefresh}
          setOpenSnack={setOpenSnack}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
          onClose={handleClose}
        />
      </OptionalWidthModal>
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      {stackAlert}
    </>
  );
};

export default ManagerOperation;
